<template>
  <ion-page>
    <ion-header class="ion-no-border events-page-header">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button text="" default-href="/events"></ion-back-button>
        </ion-buttons>
        <ion-title>Оплата</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="main-background events-content" :fullscreen="true">
      <div class="ion-padding payment-success-block">
        <div class="payment-success-icon-wrap">
          <ion-icon :icon="checkmarkCircleOutline" class="payment-success-icon"></ion-icon>
        </div>
        <h1 class="payment-success-title">Оплата прошла</h1>
        <p class="payment-success-text">
          <template v-if="isReleasePurchase">
            Спасибо за оплату. Доступ к релизу будет подтверждён автоматически. Если контент не открылся, вернитесь в раздел «Релизы от Лиги» и обновите список.
          </template>
          <template v-else>
            Спасибо за оплату. Регистрация на событие подтверждена. Если статус не обновился сразу, обновите страницу события.
          </template>
        </p>
        <ion-button v-if="!isReleasePurchase" expand="block" class="event-register-btn" @click="goToEvents">
          К событиям
        </ion-button>
        <ion-button v-if="isReleasePurchase" expand="block" class="event-register-btn" @click="goToPrograms">
          К релизам
        </ion-button>
        <ion-button
          v-if="!isReleasePurchase && eventId"
          expand="block"
          fill="outline"
          class="event-detail-btn"
          @click="goToEvent"
        >
          Вернуться к событию
        </ion-button>
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonPage,
  IonTitle,
  IonToolbar
} from '@ionic/vue';
import { checkmarkCircleOutline } from 'ionicons/icons';
import { defineComponent, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import eventsService from '@/services/events.service';
import releasesService from '@/services/releases.service';

export default defineComponent({
  name: 'EventPaymentSuccess',
  components: {
    IonBackButton,
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonPage,
    IonTitle,
    IonToolbar
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const eventId = computed(() => {
      const id = route.query.eventId ?? route.params.eventId;
      return id ? String(id) : null;
    });
    const purchaseId = computed(() => {
      const id = route.query.purchaseId;
      return id ? String(id) : null;
    });
    const isReleasePurchase = computed(() => {
      const pid = purchaseId.value ? Number(purchaseId.value) : 0;
      if (!pid) return false;
      return route.query.releasePaid === '1' || route.query.releaseId != null;
    });
    const goToEvents = () => router.push('/events');
    const goToPrograms = () => router.push('/programs');
    const goToEvent = () => {
      if (eventId.value) router.push(`/events/${eventId.value}`);
      else router.push('/events');
    };
    onMounted(() => {
      if (isReleasePurchase.value && purchaseId.value) {
        const pid = Number(purchaseId.value);
        if (pid) releasesService.syncMyPurchase(pid);
        return;
      }
      if (eventId.value) {
        const id = Number(eventId.value);
        if (id) eventsService.syncMyPayment(id);
      }
    });
    return {
      checkmarkCircleOutline,
      eventId,
      isReleasePurchase,
      goToEvents,
      goToPrograms,
      goToEvent
    };
  }
});
</script>

<style scoped>
.payment-success-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-top: 2rem;
}
.payment-success-icon-wrap {
  margin-bottom: 1.5rem;
}
.payment-success-icon {
  font-size: 80px;
  color: var(--ion-color-success);
}
.payment-success-title {
  font-size: 1.5rem;
  color: #fff;
  margin-bottom: 0.75rem;
}
.payment-success-text {
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 2rem;
  max-width: 320px;
}
</style>
